import Vuetify from 'vuetify/lib'
import i18n from '@/i18n/i18n'
import darkPalette from '@/theme/dark/colors/theme.scss'
import store from '@/store'
export function initVuetify () {
  // add translation method so vuetify can access i18n catalogs
  return new Vuetify({
    lang: {
      t: (key, ...params) => i18n.t(key, params)
    },
    theme: {
      dark: store.getters['userDataStore/useDarkColors'],
      themes: {
        light: { ...store.getters['themeStore/getPalette'] },
        dark: { ...darkPalette }
      },
      options: { customProperties: true }
    }
  })
}
